import classNames from 'classnames';
import { ErrorMessage, Field, useField, useFormikContext } from 'formik';
import React, { useState } from 'react';
import FormField from '../FormField/FormField';
import { FormFieldBlokProps } from '../FormFieldBlokProps.interface';
import { NumericFormat } from 'react-number-format';

export type InputType = 'text' | 'email' | 'number' | 'password';

interface FieldHookProps {
  name: string;
  placeholder?: string;
  className: string;
  autoComplete: string;
  type: InputType;
  setValue: (val: string | number) => void;
  value: string | number;
}

const numberedFieldKeys = ['price', 'buyPrice', 'sellPrice'];

const FieldHook: React.FC<FieldHookProps> = ({
  name,
  placeholder,
  className,
  autoComplete,
  type,
  setValue,
  value,
}) => {
  const [field] = useField(name);

  if (numberedFieldKeys.includes(name)) {
    return (
      <>
        <NumericFormat
          {...field}
          decimalScale={0}
          allowNegative={false}
          thousandSeparator=","
          className={className}
          placeholder={placeholder}
          value={value}
          onValueChange={(e) => setValue(e.value)}
        />
      </>
    );
  }
  return (
    <Field
      type={type === 'email' ? 'email' : 'text'}
      name={name}
      className={className}
      placeholder={placeholder}
      autoComplete={autoComplete}
    />
  );
};

export default FieldHook;
